<template>
  <header class="article-head">
    <ArticleCoverMedia :cover_media="cover_media" v-if="cover_media">
      <div class="article-head__title" v-if="title">
        <h2>{{ title }}</h2>
      </div>
    </ArticleCoverMedia>

    <ArticleHeadMenu
      v-if="!isNested && !isHomePath && !isFestivalYear && isMobile"
      :referenceType="referenceType"
      :articleID="articleID"
      :class="[{ 'article-head__menu__nav--empty': !isAnyDetailExist }]"
    />

    <AccesskeyLink
      v-if="isMainContent"
      :id="isMainContent ? 'mainContent' : ''"
      :title="isMainContent ? ':::主要內容顯示區' : ''"
      class="accesskey-c"
      accesskey="C"
    />

    <ArticleHeadOtherFields
      v-if="!isNested && !isHomePath && !isFestivalYear && isMobile"
      :identity="identity"
      :space="space"
      :address="address"
      :telephone="telephone"
      :openingInfo="openingInfo"
      :isNested="isNested"
    />

    <ArticleHeadOtherFields
      v-if="isFestivalYearActivityArticle"
      :template="template"
      :startDate="startDate"
      :endDate="endDate"
      :lunarDate="lunarDate"
      :activityFeature="activityFeature"
      :address="address"
      :isNested="isNested"
    />
    <ArticleHeadOtherFields
      v-if="isFestivalYearInformationArticle"
      :template="template"
      :updateDate="updateDate"
      :isNested="isNested"
    />

    <slot name="homeSearchbar"></slot>
    <slot name="searchInput"></slot>
  </header>
</template>

<script>
import ArticleCoverMedia from "@/components/article/ArticleCoverMedia";
import ArticleHeadOtherFields from "@/components/article/ArticleHeadOtherFields";
import ArticleHeadMenu from "@/components/article/ArticleHeadMenu";
import AccesskeyLink from "@/components/a11y/AccesskeyLink.vue";

export default {
  name: "ArticleMastHead",
  props: {
    title: {
      type: String,
      default: "",
    },
    cover_media: {
      type: Object,
      default: () => {},
    },
    identity: {
      type: String,
      default: "",
    },
    space: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    telephone: {
      type: String,
      default: "",
    },
    openingInfo: {
      type: String,
      default: "",
    },
    template: {
      type: String,
      default: "",
    },
    updateDate: {
      type: String,
      default: "",
    },
    startDate: {
      type: String,
      default: "",
    },
    endDate: {
      type: String,
      default: "",
    },
    lunarDate: {
      type: String,
      default: "",
    },
    activityFeature: {
      type: String,
      default: "",
    },
    isNested: {
      type: Boolean,
      default: false,
    },
    referenceType: {
      type: Number,
      default: 0,
    },
    articleID: {
      type: Number,
      default: 0,
    },
    isHomePath: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isMainContent: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    isAnyDetailExist() {
      return (
        !!this.identity ||
        !!this.space ||
        !!this.address ||
        !!this.telephone ||
        !!this.openingInfo
      );
    },
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
    isFestivalYearActivityArticle() {
      return (
        !this.isNested &&
        !this.isHomePath &&
        this.isFestivalYear &&
        this.template === "activity"
      );
    },
    isFestivalYearInformationArticle() {
      return (
        !this.isNested &&
        !this.isHomePath &&
        this.isFestivalYear &&
        this.template === "information"
      );
    },
  },

  methods: {},
  components: {
    ArticleCoverMedia,
    ArticleHeadOtherFields,
    ArticleHeadMenu,
    AccesskeyLink,
  },
};
</script>

<style lang="scss" scoped>
$titleFontSizes: (
  "mobile": 26px,
  "tablet": 30px,
  "desktop": 38px,
);

.article-head {
  position: relative; // for search bar positioning
  padding-top: 1px;

  &__title {
    text-align: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: rgba($color-bg, 0.55);

    @include for-tablet {
      box-shadow: inset 0 -20px 30px $color-bg,
        inset 0 -15px 20px rgba($color-bg, 0.5);
    }

    > h2 {
      position: relative; // 防止標題文字太長，被左右兩邊的花邊遮住
      z-index: 1;
      font-size: map-get($titleFontSizes, mobile);
      margin: 20px 0;
    }
  }

  // override margins when detail is empty
  .article-head__menu__nav--empty {
    margin-top: 0;
  }
}
</style>
